<template>

	<div id="app" v-if="isFull">

		<nav-header />

		<router-view class="view-content"></router-view>

		<contact-section v-if="contactSection && isNotTextual" />

		<nav-footer
			@displaySiteMap="$refs.siteMapModal.display()"
			:hide-logo-belt="!isNotTextual"
		/>

	</div>

</template>

<script>
/* eslint-disable */
import navHeader from './components/nav-header.vue';
import navFooter from './components/nav-footer.vue';
import contactSection from './components/contact-section.vue';

import { mapActions } from 'vuex';

export default {
	name: 'App',

	props: {
		contactSection: {
			type: Boolean,
			default: true
		},
	},

	computed: {

		isNotTextual() {

			const textualRoutes = [
				'Page',
				'ArticleDetail',
				'PrivacyPolicy',
				'TermsConditions',
				'Cookies'
			];

			return !textualRoutes.includes(this.$route.name);

		}

	},

	components: {
		navHeader,
		navFooter,
		contactSection
	},

	data: () => {
		return {
			sample: false,
			isFull: true
		};
	},

	mounted() {

		if (window.mainUI && typeof window.mainUI === 'function')
			window.mainUI();

	},

	beforeUnmount() {

		window.removeEventListener('resize', this.adjustViewMargin);

	},

	watch: {

		$route(to, from) {

			if (this.isFull && to.name && to.name !== from.name) {

				this.$nextTick(() => {
					this.scrollTo();
				});

			}

		},

	},

	methods: {

		...mapActions(['catalogUpdate']),

		scrollTo() {

			window.scrollTo({
				top: 0,
			});

		},

		adjustViewMargin() {

			const footer = document.getElementById('nav-footer');
			const view = document.getElementById('view');

			if (footer && view) {
				view.style.marginBottom = `${footer.offsetHeight - 80 / 2}px`;
			}

			setTimeout(() => {
				this.adjustHeaderMargin();
			}, 400);

		},

		adjustHeaderMargin() {

			const header = document.getElementById('nav-header');
			const view = document.getElementById('view');

			if (header && view) {
				view.style.marginTop = `${header.offsetHeight}px`;
			}

		},

		loadScript(scriptURI) {

			var script = document.createElement("script");

			script.setAttribute("src", scriptURI);
			script.setAttribute("type", "text/javascript");

			document
				.getElementsByTagName("head")[0]
				.appendChild(script);

		}

	},

	async beforeMount() {

		this.isFull = false;

		try {

			await this.catalogUpdate();

			document.addEventListener('DOMContentLoaded', () => {
				this.isFull = true;
			});

		} catch (error) {

			console.error('Error updating catalog:', error);

		} finally {

			this.isFull = true;

		}

	}

}
</script>